export default "__VITE_ASSET__CWpalu_k__"